export default __webpack_public_path__ + "static/media/children-hooray.236a5616.mp3";